"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _usageTrackerPublic = require("usage-tracker-public");

var _events = _interopRequireDefault(require("../../events.yaml"));

var _AppConstants = require("../constants/AppConstants");

var _LanguageUtil = _interopRequireDefault(require("../util/LanguageUtil"));

var appName = 'WebsiteGrader';
var listenToEvents = [_AppConstants.ActionTypes.GRADE_WEBSITE, _AppConstants.ActionTypes.WEBSITE_GRADED, _AppConstants.ActionTypes.WEBSITE_GRADED_ERROR, _AppConstants.ActionTypes.MARKETING_FREE_MODAL_OPENED, _AppConstants.ActionTypes.MARKETING_FREE_MODAL_CLOSED, _AppConstants.ActionTypes.MARKETING_FREE_MODAL_LINK_CLICKED];

var UsageTracker =
/*#__PURE__*/
function () {
  function UsageTracker() {
    (0, _classCallCheck2.default)(this, UsageTracker);
    this.tracker = (0, _usageTrackerPublic.createTracker)({
      events: _events.default,
      properties: {
        namespace: appName
      },
      lastKnownEventProperties: ['view']
    });
  }

  (0, _createClass2.default)(UsageTracker, [{
    key: "log",
    value: function log() {
      var eventKey = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var eventProperties = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      this.tracker.track(eventKey, eventProperties);
    }
  }, {
    key: "logView",
    value: function logView(view) {
      if (view) {
        this.log('pageView', {
          // Capitalize the first letter of the view
          view: view,
          language: _LanguageUtil.default.getPrintUserLanguage()
        });
      }
    }
  }, {
    key: "logExposure",
    value: function logExposure(treatmentKey, websiteUrl, key, value) {
      this.log('experimentExposure', {
        treatmentKey: treatmentKey,
        websiteUrl: websiteUrl,
        key: key,
        value: value
      });
    }
  }, {
    key: "logAction",
    value: function logAction(data) {
      this.log('genericAction', data);
    }
  }, {
    key: "logStateChange",
    value: function logStateChange(_ref) {
      var routes = _ref.routes;

      if (!routes[1]) {
        return;
      }

      var view = routes[1].name;
      this.logView(view);
    }
  }, {
    key: "logActionChange",
    value: function logActionChange(action) {
      var type = action.type,
          payload = action.payload;
      var resultAction = {
        type: type
      }; // Ignore some events

      if (listenToEvents.indexOf(type) < 0) {
        return;
      }

      if (type === _AppConstants.ActionTypes.GRADE_WEBSITE || type === _AppConstants.ActionTypes.WEBSITE_GRADED_ERROR) {
        resultAction.website = payload.websiteUrl;
      } else if (type === _AppConstants.ActionTypes.WEBSITE_GRADED) {
        resultAction.website = payload.get('domain');
      }

      this.logAction(resultAction);
    }
  }]);
  return UsageTracker;
}();

var _default = new UsageTracker();

exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./js/lib/usageTracker.js
// module id = 41
// module chunks = 0